import React from "react";
import {
  OverflowContainer,
  ContentContainer,
  NavigationWrapper,
  NavigationContainer,
  ImageContainer,
  PLPContent,
  PDPId,
  ArchiveWrapper,
  Headline,
  Link,
  ArchiveContent,
  Image,
} from "../styles/components/PLP/Navigation";

const NavigationItems = ({
  overflowContainerRef,
  navigationParentRef,
  archiveContainerRef,
  navigationItems,
  aboutArchiveContent,
  navigationSelect,
}) => {
  return (
    <OverflowContainer ref={overflowContainerRef}>
      <ArchiveWrapper ref={archiveContainerRef}>
        {aboutArchiveContent.map(({ key, archiveContent }, index) => (
          <ArchiveContent key={key} id={index}>
            {archiveContent && (
              <Headline
                dangerouslySetInnerHTML={{
                  __html: archiveContent,
                }}
              />
            )}
            <Headline $margin>
              Want to see more of what GANT is up to today? Check out their
              current collections <Link href="https://gant.com/">here</Link>.
            </Headline>
          </ArchiveContent>
        ))}
      </ArchiveWrapper>
      <NavigationWrapper ref={navigationParentRef}>
        {navigationItems.map(
          ({ key, pdpPrimaryImage, pdpParagraphsText }, index) => (
            <NavigationContainer
              key={key}
              id={index}
              onClick={navigationSelect}
              $justifyId={index}
            >
              <ContentContainer>
                {pdpPrimaryImage && (
                  <ImageContainer
                    $aspectRatio={pdpPrimaryImage.image.fluid.aspectRatio}
                  >
                    <Image src={pdpPrimaryImage.image.fluid.src} />
                  </ImageContainer>
                )}
                {pdpParagraphsText && (
                  <PLPContent>
                    <PDPId
                      $whiteWrap
                      dangerouslySetInnerHTML={{
                        __html: pdpParagraphsText,
                      }}
                    />
                  </PLPContent>
                )}
              </ContentContainer>
            </NavigationContainer>
          )
        )}
      </NavigationWrapper>
    </OverflowContainer>
  );
};

export default NavigationItems;
